import { AutocompleteRenderOptionState } from '@mui/material';
import { CuriosityTranslationOrKey, isCuriosityTranslation } from '@procureai/curiosity-ui-mui';
import { CuriosityAutocompleteOptionWithTag } from '@procureai/ui-form-mui';

/**
 * Renders a Curiosity autocomplete option with a source reference tag.
 *
 * @param params - The HTML attributes to apply to the option element
 * @param option - The Curiosity translation option
 * @param _state - The autocomplete option state (unused)
 * @param ownerState - The owner state containing getOptionLabel function
 * @returns A CuriosityAutocompleteOptionWithTag component
 */
export const renderCuriosityOptionWithSourceReference = (
  params: React.HTMLAttributes<HTMLLIElement>,
  option: CuriosityTranslationOrKey<Record<string, any>>,
  _state: AutocompleteRenderOptionState,
  ownerState: { getOptionLabel: (option: CuriosityTranslationOrKey<Record<string, any>>) => string },
) => {
  const label = ownerState.getOptionLabel(option);

  if (!isCuriosityTranslation(option)) {
    return <CuriosityAutocompleteOptionWithTag {...params} text={label} />;
  }
  const sourceReference = option.entity.primarySourceReference ?? option.entity.sourceReference ?? undefined;
  return <CuriosityAutocompleteOptionWithTag {...params} text={label} tagText={sourceReference} />;
};
